import { atom } from 'jotai';

// Atoms
const searchQueryAtom = atom('');

export default searchQueryAtom;
